@if (shouldShowMessageWindow(pushMessagesService.messages)) {  
    <div class="fixed-bottom">
        <div class="chat-window-header d-flex justify-content-between align-items-center col-sm-10 col-md-5 col-lg-4 col-xl-3">
            <div style="margin-left: 20px">
                Message from Zint
            </div>
            <div (click)="closeMessageWindow()" class="chat-window-header-text-close" style="margin-right: 20px">
                x
            </div>
        </div>
        <div class="chat-window col-sm-10 col-md-5 col-lg-4 col-xl-3">  
            @for (msg of pushMessagesService.messages; track $index) { 
                @if (!msg.is_popup) {
                    <div class="message">
                        <div [innerHTML]="msg.message">                       
                        </div>
                        <div *ngIf="msg.embed_url" class="ratio ratio-16x9">
                            <iframe class="" [src]="msg.embed_url | safe" frameborder="0" allowfullscreen></iframe>
                        </div>
                    </div>                
                    <div class="ignore-text" (click)="ignorePushMessage(msg)">Ignore</div>           
                }                              
        }

             <button class="rounded-btn-base rounded-btn-dark-hover btn-p-lg mt-2" (click)="openZendeskChat()">
                Respond
            </button>
        </div>
    </div>
}
